import { useEffect, useState } from "react";

const simpleNav = [
  { label: "ホーム", href: "/" },
  { label: "パートナーシップ", href: "/#partnership" },
  { label: "よくあるご質問", href: "/#faq" },
];

interface HeaderProps {
  showBusinessContent?: boolean;
}

export default function Header({ showBusinessContent = true }: HeaderProps) {
  void showBusinessContent;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const filteredNav = simpleNav;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2 shrink-0">
            <div className="hidden sm:flex flex-col leading-tight">
              <span className={`font-bold text-sm md:text-base transition-colors ${isScrolled ? "text-gamo-black" : "text-white"}`}>
                株式会社TBM健康美容研究所
              </span>
              <span className={`text-[10px] md:text-xs transition-colors ${isScrolled ? "text-gamo-medium-gray" : "text-white/70"}`}>
                TBM Health & Beauty Research Institute
              </span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            <div className="flex items-center gap-1">
              {filteredNav.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className={`flex items-center gap-1 px-4 py-2 text-sm font-medium transition-colors rounded-md hover:text-gamo-green ${
                    isScrolled ? "text-gamo-dark-gray" : "text-white"
                  }`}
                >
                  {item.label}
                </a>
              ))}
            </div>
          </nav>

          {/* Right side buttons */}
          <div className="flex items-center gap-3">
            {/* Contact Button */}
            <a
              href="/#contact"
              className="hidden md:inline-flex items-center gap-2 bg-gamo-green text-white text-sm font-medium px-4 py-2.5 rounded-full transition-all duration-300 hover:bg-gamo-green-dark whitespace-nowrap"
            >
              <i className="ri-mail-line text-sm"></i>
              <span>お問い合わせ</span>
            </a>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
                isScrolled ? "text-gamo-black" : "text-white"
              }`}
            >
              <i className={`ri-${isMobileMenuOpen ? "close" : "menu"}-line text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gamo-border-gray shadow-lg animate-fade-in">
          <div className="px-4 py-4 space-y-1">
            {filteredNav.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="flex items-center px-3 py-3 text-sm font-medium text-gamo-dark-gray hover:text-gamo-green hover:bg-gamo-light-gray rounded-md"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
            <div className="pt-4 space-y-2">
              <a
                href="/#contact"
                className="flex items-center justify-center gap-2 bg-gamo-green text-white text-sm font-medium px-4 py-3 rounded-full"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <i className="ri-mail-line"></i>
                <span>お問い合わせ</span>
              </a>

            </div>
          </div>
        </div>
      )}
    </header>
  );
}